import { PropsWithChildren } from 'react';

export interface FormfieldProps extends PropsWithChildren {
  /** Label */
  label?: string;
  /** The ID of the field the label is for */
  htmlFor?: string;
  /** Description */
  description?: string;
  /** Error message */
  errorMessage?: string;
  /** Required */
  isRequired?: boolean;
  /** Label, indicating that the field is required */
  labelRequired?: string;
  /** Additional class */
  className?: string;
}

/** An form field */
export const Formfield = ({
  label,
  htmlFor,
  description,
  errorMessage,
  isRequired = false,
  labelRequired,
  className,
  children,
}: FormfieldProps) => {
  return (
    <div className={['formfield', className].join(' ')}>
      {label && (
        <label className="formfield__label" htmlFor={htmlFor}>
          {label}
          {isRequired && (
            <span className="formfield__required">
              {labelRequired || 'required'}
            </span>
          )}
        </label>
      )}
      <div className="formfield__field">{children}</div>
      {errorMessage && <div className="formfield__error">{errorMessage}</div>}
      {description && (
        <div className="formfield__description">{description}</div>
      )}
    </div>
  );
};
